import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { useHistory } from "react-router-dom";

const locations =[
  { id: '1', name: 'Adnoc', position: [24.4792951,54.344354], avatar:'Adnoc.jpg'},
  { id: '2', name: 'Dhaid', position: [25.2999938,55.9558873], avatar:'Dhaid.jpg'},
  { id: '3', name: 'Hatta', position: [24.8106093,56.0768879], avatar:'Hatta.jpg'},
  { id: '4', name: 'Jabel Hafeet', position: [24.0566826,55.777073], avatar:'JabelHafeet.jpg'},
  { id: '5', name: 'MOPA', position: [24.4533794,54.3167099], avatar:'MOPA.jpg'},
  { id: '6', name: 'NCM HQ', position: [224.3383579,54.6389123], avatar:'NCM.jpg'},
  { id: '7', name: 'Shuwaib', position: [24.7558259,55.7849093], avatar:'Shuwaib.jpg'},
  { id: '8', name: 'SkyTower', position: [24.4962622,54.4086913], avatar:'SkyTower.jpg'},
];

const avatarPath = '/locations/avatars/'

export default (props) => {
  const history = useHistory();
  return (
    <Drawer anchor="right" open={props.expand} onClose={() => props.onChange()}>
      <List component="nav" aria-label="secondary mailbox folders">
      {
        locations.map((l,i) => (
          <React.Fragment key={l.id}>
            <ListItem button onClick={()=> history.push('/location')}>
               <ListItemAvatar>
                 <Avatar alt="Remy Sharp" src={ avatarPath + l.avatar } />
               </ListItemAvatar>
               <ListItemText primary={l.name} />
             </ListItem>
             <Divider />
           </React.Fragment>
        ))
      }

      </List>
    </Drawer>
  );
}
